import React, { useMemo } from 'react'
import './mappings.css'
import FieldMapper from './Subcomponents/FieldMapper/FieldMapper'
import { UnsavedChangesProvider } from './Subcomponents/FieldMapper/UnsavedChangesGuard'

/**
 * Field Mapper workspace for one connector: entities on the left, the mapping canvas on
 * the right. Rendered by the ProductMappings page (PATH.PRODUCT_MAPPINGS), which the
 * connector's Mappings tab navigates to and which lists the virtual entities (mode="virtual"),
 * and for the Attribute Mappings tab (PATH.PRODUCT_ATTRIBUTE_MAPPINGS), which lists the normal ones. The earlier per-type screens (Shipping/Payment
 * Method, Multi Location, Product/Customer Attribute, Sales Person) are still in
 * Subcomponents but are no longer shown.
 */
const Mappings = ({ connector, mode, title }) => {
    const { connectorId, instanceId, source, target } = connector
    // The subscription id lives on the connection, not the instance; the Field Mapper needs it.
    const instance = useMemo(
        () => ({ ...connector.instance, subscriptionId: connector.instance?.subscriptionId ?? connector.subscriptionId }),
        [connector.instance, connector.subscriptionId]
    )

    return (
        // Asks to save before leaving the page or switching entity while there are unsaved mappings
        <UnsavedChangesProvider>
            <FieldMapper
                connectorId={connectorId}
                instancesId={instanceId}
                instance={instance}
                mode={mode}
                title={title}
                sourceShortName={source.shortName}
                targetShortName={target.shortName}
            />
        </UnsavedChangesProvider>
    )
}

export default Mappings
